<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>题库管理</el-breadcrumb-item>
      <el-breadcrumb-item>测试管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区 -->
    <el-card class="box-card">
      <div slot="header" class="flexContainer">
        <span class="cardHeader">测试管理</span>
        <el-button type="primary" icon="el-icon-plus" size="normal" @click="handleCreate">创建测试</el-button>
      </div>

      <!-- 数据表格 -->
      <el-table :data="list" border stripe v-loading="loading">
        <el-table-column type="index" label="#" width="60"></el-table-column>
        <el-table-column prop="title" label="测试名称" min-width="200"></el-table-column>
        <el-table-column label="题目数量" width="100">
          <template slot-scope="scope">
            {{ scope.row.questions ? scope.row.questions.length : 0 }}
          </template>
        </el-table-column>
        <el-table-column prop="passScore" label="及格分数" width="100"></el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 'active' ? 'success' : 'info'" size="small">
              {{ scope.row.status === 'active' ? '进行中' : '已关闭' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="培训类型" width="120">
          <template slot-scope="scope">
            <el-tag :type="scope.row.trainingType === 'company' ? 'primary' : 'success'" size="small">
              {{ scope.row.trainingType === 'company' ? '公司培训' : '实操培训' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="recordCount" label="答题人数" width="100"></el-table-column>
        <el-table-column label="创建时间" width="180">
          <template slot-scope="scope">{{ scope.row.createDate | dateFormat }}</template>
        </el-table-column>
        <el-table-column label="操作" width="360" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="handleViewRecords(scope.row)">答题结果</el-button>
            <el-button type="warning" size="mini" @click="handleEdit(scope.row)">修改</el-button>
            <el-button type="success" size="mini" @click="handleShare(scope.row)">分享</el-button>
            <!-- <el-button v-if="scope.row.status === 'active'" type="warning" size="mini" @click="handleClose(scope.row)">关闭</el-button> -->
            <el-button type="danger" size="mini" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-card>

    <!-- 创建测试对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="createDialogVisible"
      width="600px"
      :close-on-click-modal="false"
      @closed="resetCreateForm">
      <el-form ref="createFormRef" :model="createForm" :rules="createRules" label-width="100px">
        <el-form-item label="测试名称" prop="title">
          <el-input v-model="createForm.title" placeholder="请输入测试名称"></el-input>
        </el-form-item>
        <el-form-item label="及格分数" prop="passScore">
          <el-input-number v-model="createForm.passScore" :min="0" :max="100" controls-position="right" style="width: 100%"></el-input-number>
        </el-form-item>
        <el-form-item label="培训类型" prop="trainingType">
          <el-radio-group v-model="createForm.trainingType">
            <el-radio label="company">公司培训</el-radio>
            <el-radio label="practical">实操培训</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="抽题规则" prop="rules">
          <div class="rules-container">
            <div v-for="(rule, index) in createForm.rules" :key="index" class="rule-row">
              <el-select v-model="rule.category" placeholder="选择分类" style="width: 200px;">
                <el-option v-for="cat in categoryList" :key="cat._id" :label="cat.name" :value="cat._id"></el-option>
              </el-select>
              <el-input-number v-model="rule.count" :min="1" :max="100" controls-position="right" placeholder="抽取数量" style="width: 150px; margin-left: 10px;"></el-input-number>
              <el-button
                v-if="createForm.rules.length > 1"
                type="danger"
                icon="el-icon-delete"
                circle
                size="mini"
                style="margin-left: 10px;"
                @click="removeRule(index)">
              </el-button>
            </div>
            <el-button type="primary" size="small" icon="el-icon-plus" @click="addRule" style="margin-top: 10px;">添加规则</el-button>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="createDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="handleCreateSubmit">{{ submitting ? '提交中...' : '确定' }}</el-button>
      </span>
    </el-dialog>

    <!-- 分享链接对话框 -->
    <el-dialog
      title="分享测试链接"
      :visible.sync="shareDialogVisible"
      width="480px"
      :close-on-click-modal="false"
      @closed="handleShareDialogClosed">
      <div class="success-content">
        <p class="success-tip">请将以下链接发送给需要答题的人员：</p>
        <div class="link-box">
          <el-input v-model="examLink" readonly>
            <el-button slot="append" icon="el-icon-document-copy" @click="copyLink">复制</el-button>
          </el-input>
        </div>
        <p class="share-exam-title">{{ shareExamTitle }}</p>
        <div class="qrcode-box">
          <p>扫描二维码直接访问：</p>
          <canvas id="qrcode-canvas"></canvas>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="shareDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from 'qrcode'

export default {
  name: 'ExamList',
  data () {
    // 验证抽题规则
    const validateRules = (rule, value, callback) => {
      if (!value || value.length === 0) {
        callback(new Error('至少添加一条抽题规则'))
      } else {
        // 检查每条规则是否填写完整
        const incomplete = value.some(r => !r.category || !r.count || r.count < 1)
        if (incomplete) {
          callback(new Error('请完善每条规则的分类和数量'))
        } else {
          callback()
        }
      }
    }

    return {
      // 列表数据
      list: [],
      total: 0,
      loading: false,
      // 查询条件
      queryInfo: {
        pagenum: 1,
        pagesize: 20
      },
      // 分类列表
      categoryList: [],
      // 创建测试弹窗
      createDialogVisible: false,
      submitting: false,
      // 对话框模式
      dialogMode: 'create', // 'create' 或 'edit'
      dialogTitle: '创建测试',
      editExamId: null, // 正在编辑的测试ID
      createForm: {
        title: '',
        passScore: 60,
        trainingType: '',
        rules: [{ category: '', count: 1 }]
      },
      // 表单验证规则
      createRules: {
        title: [
          { required: true, message: '请输入测试名称', trigger: 'blur' }
        ],
        passScore: [
          { required: true, message: '请输入及格分数', trigger: 'blur' }
        ],
        trainingType: [
          { required: true, message: '请选择培训类型', trigger: 'change' }
        ],
        rules: [
          { validator: validateRules, trigger: 'change' }
        ]
      },
      // 分享链接弹窗
      shareDialogVisible: false,
      // 考试链接
      examLink: '',
      // 分享弹窗测试名称
      shareExamTitle: ''
    }
  },
  created () {
    this.getList()
    this.getCategoryList()
  },
  methods: {
    // ========== 数据获取 ==========

    /** 获取测试列表 */
    async getList () {
      this.loading = true
      try {
        const { data: res } = await this.$http.get('tiku/exam/list', {
          params: {
            pagenum: this.queryInfo.pagenum,
            pagesize: this.queryInfo.pagesize
          }
        })
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.list = res.data.list
        this.total = res.data.total
      } catch (error) {
        this.$message.error('获取测试列表失败')
      } finally {
        this.loading = false
      }
    },

    /** 获取分类列表 */
    async getCategoryList () {
      try {
        const { data: res } = await this.$http.get('tiku/category/list')
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.categoryList = res.data.list
      } catch (error) {
        this.$message.error('获取分类列表失败')
      }
    },

    // ========== 分页 ==========

    /** 每页数量变更 */
    handleSizeChange (val) {
      this.queryInfo.pagesize = val
      this.getList()
    },

    /** 页码变更 */
    handleCurrentChange (val) {
      this.queryInfo.pagenum = val
      this.getList()
    },

    // ========== 创建测试 ==========

    /** 点击修改按钮 */
    handleEdit (row) {
      this.dialogMode = 'edit'
      this.dialogTitle = '修改测试'
      this.editExamId = row._id

      // 填充表单数据
      this.createForm = {
        title: row.title,
        passScore: row.passScore,
        trainingType: row.trainingType || '',
        rules: row.rules.map(r => ({
          category: r.category._id || r.category,
          count: r.count
        }))
      }

      this.createDialogVisible = true
    },

    /** 点击创建测试按钮 */
    handleCreate () {
      this.createDialogVisible = true
    },

    /** 添加抽题规则 */
    addRule () {
      this.createForm.rules.push({ category: '', count: 1 })
    },

    /** 删除抽题规则 */
    removeRule (index) {
      this.createForm.rules.splice(index, 1)
    },

    /** 提交创建测试 */
    async handleCreateSubmit () {
      const valid = await this.$refs.createFormRef.validate().catch(() => false)
      if (!valid) return

      this.submitting = true
      try {
        const submitData = {
          title: this.createForm.title,
          passScore: this.createForm.passScore,
          trainingType: this.createForm.trainingType,
          rules: this.createForm.rules.map(r => ({
            category: r.category,
            count: r.count
          }))
        }

        let res
        if (this.dialogMode === 'create') {
          // 创建测试
          res = await this.$http.post('tiku/exam/add', submitData)
        } else {
          // 修改测试
          res = await this.$http.put(`tiku/exam/modify/${this.editExamId}`, submitData)
        }

        if (res.data.meta.status !== 200) {
          return this.$message.error(res.data.meta.msg)
        }

        this.$message.success(this.dialogMode === 'create' ? '创建成功' : '修改成功')
        this.createDialogVisible = false

        // 创建成功时显示分享弹窗
        if (this.dialogMode === 'create') {
          this.showShareDialog(res.data.data.code || res.data.data.examId || res.data.data._id, this.createForm.title)
        }

        this.getList()
      } catch (error) {
        this.$message.error(this.dialogMode === 'create' ? '创建测试失败' : '修改测试失败')
      } finally {
        this.submitting = false
      }
    },

    /** 复制链接 */
    async copyLink () {
      try {
        await navigator.clipboard.writeText(this.examLink)
        this.$message.success('链接已复制到剪贴板')
      } catch (err) {
        // 降级方案：使用传统复制方式
        const input = document.createElement('input')
        input.value = this.examLink
        document.body.appendChild(input)
        input.select()
        document.execCommand('copy')
        document.body.removeChild(input)
        this.$message.success('链接已复制到剪贴板')
      }
    },

    /** 重置创建表单 */
    resetCreateForm () {
      this.dialogMode = 'create'
      this.dialogTitle = '创建测试'
      this.editExamId = null
      this.createForm = {
        title: '',
        passScore: 60,
        trainingType: '',
        rules: [{ category: '', count: 1 }]
      }
      this.$refs.createFormRef && this.$refs.createFormRef.resetFields()
    },

    /** 成功弹窗关闭回调 */
    handleShareDialogClosed () {
      this.examLink = ''
      this.shareExamTitle = ''
    },

    /** 显示分享弹窗 */
    showShareDialog (code, title) {
      const base = window.sessionStorage.getItem('base') || window.location.origin
      this.examLink = `${base}/public/h5/index.html?code=${code}`
      this.shareExamTitle = title || ''
      this.shareDialogVisible = true
      this.$nextTick(async () => {
        try {
          const canvas = document.getElementById('qrcode-canvas')
          if (canvas) {
            await QRCode.toCanvas(canvas, this.examLink, { width: 200 })
          }
        } catch (err) {
          console.error('生成二维码失败', err)
        }
      })
    },

    /** 点击分享按钮 */
    handleShare (row) {
      this.showShareDialog(row.code, row.title)
    },

    // ========== 操作 ==========

    /** 查看答题结果 */
    handleViewRecords (row) {
      this.$router.push(`/tiku/record?examId=${row._id}`)
    },

    /** 关闭测试 */
    async handleClose (row) {
      const confirmResult = await this.$confirm(
        `确定要关闭测试「${row.title}」吗？关闭后将无法继续答题。`,
        '确认关闭',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(() => {})

      if (confirmResult !== 'confirm') return this.$message.info('操作已取消')

      try {
        const { data: res } = await this.$http.put(`tiku/exam/close/${row._id}`)
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.$message.success('测试已关闭')
        this.getList()
      } catch (error) {
        this.$message.error('关闭操作失败')
      }
    },

    /** 删除测试 */
    async handleDelete (row) {
      const confirmResult = await this.$confirm(
        `确定要删除测试「${row.title}」吗？`,
        '确认删除',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(() => {})

      if (confirmResult !== 'confirm') return this.$message.info('操作已取消')

      try {
        const { data: res } = await this.$http.delete(`tiku/exam/remove/${row._id}`)
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.$message.success('删除成功')
        this.getList()
      } catch (error) {
        this.$message.error('删除操作失败')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.flexContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cardHeader {
  font-size: 18px;
  font-weight: bold;
}

.el-pagination {
  margin-top: 15px;
}

.rules-container {
  width: 100%;
}

.rule-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.success-content {
  text-align: center;

  .share-exam-title {
    font-size: 20px;
    font-weight: bold;
    color: #303133;
    margin-bottom: 12px;
  }

  .success-tip {
    font-size: 14px;
    color: #606266;
    margin-bottom: 20px;
  }

  .link-box {
    margin-bottom: 20px;
  }

  .qrcode-box {
    p {
      font-size: 14px;
      color: #909399;
      margin-bottom: 10px;
    }

    canvas {
      border: 1px solid #ebeef5;
      border-radius: 4px;
    }
  }
}
</style>
